import { createContext, useContext } from "react";

/** Parameters of the switchboard entry that matched, e.g. `{ id: "12" }` for "/households/:id". */
export const SwitchParamsContext = createContext<Record<string, string>>({});

/**
 * The matched entry's parameters. Works at the page's own address and in the /next/… and /legacy/… previews,
 * where react-router's `useParams()` only has `*`.
 */
export const useSwitchParams = (): Record<string, string> => useContext(SwitchParamsContext);
